import { Component, OnInit } from '@angular/core';
import { SubTopicService } from 'src/app/_services/subTopic.service';

@Component({
  selector: 'app-sub-topic-all-index',
  templateUrl: './sub-topic-all-index.component.html',
  styleUrls: ['./sub-topic-all-index.component.css']
})
export class SubTopicAllIndexComponent implements OnInit {
  subTopicList: any[] = [];
  loading = false;
  dtOptions: DataTables.Settings = {};
  title ="Sub Topic List"
  constructor(private subTopicService: SubTopicService) { }

  ngOnInit(): void {
    this.loading = true;
    this.dtOptions = {
      pagingType: 'full_numbers'
  }

    this.subTopicService.getSubTopicList().subscribe({
      next: (data) => {
        this.subTopicList = data.rs.data;
        this.loading = false;

    },
      error: (err) => {
        console.error('Error loading subtopics', err);
        this.loading = false;
  }}

)
  }

}
